<template>
    <div>
        <h5 class="title-2" :class="marginClass">{{ $t("surgery.presurgery") }}</h5>
        <h2 class="title" :class="marginClass">{{ $t('surgery.transfusion.title') }}</h2>
        <hr class="divider">

        <radio-checkbox-field
            :class="marginClass"
            :field="{label: $t('surgery.transfusion.hasTransfusionLabel')}"
            v-model="hasTransfusions"
            field-name="has-transfusions"
        />

        <div v-if="hasTransfusions" :class="marginClass">
            <div class="ml-5" v-for="(choice, index) in $v.transfusions.$each.$iter" :key="index">
                <div class="mb-2">
                    <b-form-checkbox
                        class="align-baseline mt-2"
                        :id="'tranfusion-' + index"
                        v-model="choice.selected.$model"
                        :name="'tranfusion-' + index"
                    >
                        {{ transfusionFields.transfusion_type.choices[index].display_name }}
                    </b-form-checkbox>
                </div>
                <div v-if="choice.selected.$model" class="ml-5">
                    <date-field
                        v-model="choice.date.$model"
                        :field="transfusionFields.date"
                        :field-name="'tranfusion-date-' + index"
                        :errors="choice.date.$error ? {['tranfusion-date-' + index]: [$t('error.required')] } : {}"
                        class="mb-3"
                        datetime
                    />
                    <input-field
                        v-model="choice.amount.$model"
                        :field="{label: transfusionFields.amount.label }"
                        :field-name="'tranfusion-amount-' + index"
                        :errors="choice.amount.$error ? {['tranfusion-amount-' + index]: [$t('error.required')] } : {}"
                        class="w-auto d-inline-block mb-3"
                        :unit="index === '2' ? $t('utils.ml') : $tc('utils.unit', 2)"
                    />
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import {mapState} from "vuex";
    import {mapStateProperty} from "@/utils/VuexHelpers";
    import SurgeryAddElementMixin from "@/components/mixins/NavigableComponentMixin";
    import RadioCheckboxField from "@/components/fields/RadioCheckboxField";
    import InputField from "@/components/fields/InputField";
    import {requiredIf, required} from "vuelidate/lib/validators";
    import TransfusionMixin from "@/components/surgery/create/TransfusionMixin";
    import DateField from "@/components/fields/DateField";

    export default {
        name: "Tranfusion",
        components: {
            DateField,
            InputField,
            RadioCheckboxField,
        },
        mixins: [SurgeryAddElementMixin, TransfusionMixin],
        data() {
            return {
                marginClass: 'mx-4'
            };
        },
        computed: {
            ...mapState([
                'transfusionFields',
            ]),
            ...mapStateProperty([
                {path: 'surgery.transfusions', name: 'surgeryTransfusions'},
            ]),
        },
        created() {
            this.transfusions = this.transfusionCreateTransfusions(this.surgeryTransfusions, this.transfusionFields);
            this.hasTransfusions = this.transfusionHasTransfusions(this.surgeryTransfusions);
        },
        methods: {
            back() {
                this.storeTransfusions();
            },
            validate() {
                this.$v.$touch();
                const isValid = !this.$v.$invalid;
                if (isValid) {
                    this.storeTransfusions();
                }
                return isValid;
            },
            storeTransfusions() {
                this.surgeryTransfusions = this.transfusionGetTransfusionForStoring();
            },
        },
        validations: {
            transfusions: {
                required,
                $each: {
                    selected: {},
                    amount: {
                        required: requiredIf(function (transfusion) {
                            return this.hasTransfusions && transfusion.selected;
                        }),
                    },
                    date: {
                        required: requiredIf(function (transfusion) {
                            return this.hasTransfusions && transfusion.selected;
                        }),
                    }
                }
            }
        }
    };
</script>

<style scoped>
</style>